import { Box } from '@mui/material';
import ExoAvatar from '../../exo/ExoAvatar';
import LabeledBox from '../../special/LabeledBox';
import ExoDialog from '../../exo/ExoDialog';
import { useState } from 'react';
import SelectLeadPersons from '../../select/SelectLeadPersons';

const TypeLeadPersons = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
  size,
  noPreview,
}) => {
  const [open, setOpen] = useState(false);

  const contacts = dataCollection[field.key];

  function handleSelect(element) {
    updateValidationOnChange(field.key, element);
  }

  return (
    <>
      <LabeledBox label={field.label} onClick={() => setOpen(true)} size={size}>
        {!noPreview && contacts && (
          <Box className="flex flex-col gap-2">
            {contacts?.map((contact) => (
              <Box className="flex items-center gap-2 w-full">
                <ExoAvatar
                  name={`${contact.firstName} ${contact.lastName}`}
                  size="30px"
                  type={'contact'}
                />
                {`${contact?.salutation ?? ''} ${contact?.firstName ?? ''} ${contact?.lastName ?? ''}`}
              </Box>
            ))}
          </Box>
        )}
      </LabeledBox>
      <ExoDialog open={open} onClose={() => setOpen(false)} limitWidth>
        <SelectLeadPersons onSelect={handleSelect} preSelected={contacts} />
      </ExoDialog>
    </>
  );
};

export default TypeLeadPersons;
